var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 45.012,
    viewBox: "0 0 50 45.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20999.477,14233.012a6.459,6.459,0,0,1-5.594-9.691l18.527-32.088a6.462,6.462,0,0,1,11.191,0l18.525,32.088a6.464,6.464,0,0,1-5.6,9.7Zm16.541-39.7-18.533,32.088a2.3,2.3,0,0,0,1.992,3.449h37.059a2.3,2.3,0,0,0,1.984-3.449l-18.525-32.088a2.3,2.3,0,0,0-3.977,0Zm-.16,28.624a2.5,2.5,0,0,1,5,0,2.5,2.5,0,1,1-5,0Zm.418-6.939v-11.471a2.084,2.084,0,0,1,4.168,0V14215a2.084,2.084,0,1,1-4.168,0Z",
    transform: "translate(-20993.004 -14188)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon-alert.73a479b8.svg";
export { ForwardRef as ReactComponent };